import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import { useNewsFilter } from "../features";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterActiveZoneDateButton',
    setup(__props) {
        const { getFormattedDateRange, dateRange, applyFilters, clearDateInputs } = useNewsFilter();
        const dates = computed(() => getFormattedDateRange());
        const removeDateRange = () => {
            dateRange.value = [];
            applyFilters();
            clearDateInputs();
        };
        return (_ctx, _cache) => {
            return (dates.value.startDate && dates.value.endDate)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: removeDateRange,
                    type: "button",
                    class: "filter-newsroom-event__oneFilterButton"
                }, [
                    _createElementVNode("span", null, _toDisplayString(dates.value.startDate), 1 /* TEXT */),
                    _createTextVNode(" - "),
                    _createElementVNode("span", null, _toDisplayString(dates.value.endDate), 1 /* TEXT */)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
